import "./product-option";

const INVALID_CLASS = "product-form__option-input--invalid";

class ProductFormSelectors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => this.handleChange(e.target));
  
    // Scrape initial product data
    this.data = window.scrapeSectionData(this);
    this.disableAllIfSoldOut();

    const currentVariant = this.getAttribute("current-variant");

    if (currentVariant) {
      const data = window.scrapeSectionData(this);
      const variant = data.variants.find(
        (variant) => variant.id.toString() === currentVariant,
      );

      if (variant) {
        variant.options.forEach((optionValue, i) => {
          const optionInput = this.querySelector(
            `[data-option-index="${i}"][data-option-value="${optionValue}"]`,
          );

          optionInput.checked = true;
        });
      }
    }

    const handleResize = () => {
      this.disableAllIfSoldOut();
    };
    window.addEventListener("resize", handleResize);
    this._handleResize = handleResize;
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._handleResize);
  }

  disableAllIfSoldOut() {
    const allSoldOut = this.data.variants.every(v => !v.available);
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;  
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;  
    const detailsContainer = this.querySelector("conditional-details details");
    if (!detailsContainer) return;

    const summary = detailsContainer?.querySelector("summary");

    if (allSoldOut && isDesktop) {
      this.querySelectorAll("label.product-form__option-label .product-form__option-value--disabled")
        .forEach((input) => (input.disabled = true));
    }

    if (allSoldOut && isMobile) {
      detailsContainer.removeAttribute("open");
      if (summary) {
        summary.style.pointerEvents = "none";
        summary.style.opacity = "0.5"; 
        summary.style.color = "#787878"; 
      }

      if (detailsContainer._toggleHandler) {
        detailsContainer.removeEventListener("toggle", detailsContainer._toggleHandler);
      }

      const toggleHandler = (e) => {
        if (!detailsContainer.hasAttribute("open")) {
          e.preventDefault();
          detailsContainer.removeAttribute("open");
        }
      };

      detailsContainer.addEventListener("toggle", toggleHandler);
      detailsContainer._toggleHandler = toggleHandler;
    } else if (!isMobile) {
      if (summary) {
        summary.style.pointerEvents = "";
        summary.style.opacity = "";
        summary.style.color = "";
      }
      if (detailsContainer._toggleHandler) {
        detailsContainer.removeEventListener("toggle", detailsContainer._toggleHandler);
        delete detailsContainer._toggleHandler;
      }
    }
  }

  handleChange(target) {
    this.data = window.scrapeSectionData(this);

    if(INVALID_CLASS) {
      target.classList.remove(INVALID_CLASS);
    }

    const selectedOptionValueId = parseInt(target.value, 10);
    const selectedOptionIndex = parseInt(target.dataset.optionIndex, 10);

    this.querySelectorAll("[data-option-value]").forEach((optionValue) => {
      const optionIndex = parseInt(optionValue.dataset.optionIndex);

      if (optionIndex === selectedOptionIndex) return;

      const optionValueId = parseInt(optionValue.value, 10);

      const valid = this.data.optionsByVariant.some((variant) => {
        const matchesSelectedOption =
          variant.variantOptions[selectedOptionIndex].id ===
          selectedOptionValueId;
        const matchesOptionValue =
          variant.variantOptions[optionIndex].id === optionValueId;

        return matchesSelectedOption && matchesOptionValue;
      });

      optionValue.classList.toggle(INVALID_CLASS, !valid);
    });

    const form = this.closest("form");

    const selectedOptionValueIds = new Array(this.data.productOptionsCount)
      .fill(null)
      .map((_, i) => parseInt(form[`option-${i + 1}`]?.value, 10));

    const matchingVariant = this.data.optionsByVariant.find((variant) =>
      selectedOptionValueIds.every(
        (selectedOptionValueId, i) =>
          selectedOptionValueId === variant.variantOptions[i].id,
      ),
    );

    let variant = null;
    let isWaitlist = false;
    let isComingSoon = false;
    let frameSizeVariants = [];

    if (matchingVariant) {
      variant = this.data.variants.find(
        (variant) => variant.id === matchingVariant.variantId,
      );

      const waitlistMeta = matchingVariant.metafields?.custom?.waitlist;
      const waitlistEnabled = waitlistMeta === true || waitlistMeta === "true";

      isWaitlist =
        waitlistEnabled &&
        matchingVariant.inventory_quantity <= 0 &&
        matchingVariant.inventory_policy !== "continue";

      // Detect "coming soon"
      const allSoldOut = this.data.variants.every(v => !v.available);
      const continueSelling = this.data.variants.some(v => v.inventory_policy === "continue");
      const comingSoonTag = this.data.product.tags?.includes("!coming-soon");
      isComingSoon = comingSoonTag && allSoldOut && !continueSelling;

      if (this.data.productOptionsCount > 1) {
        const matchingFrameSizeVariants = this.data.optionsByVariant.filter(
          (variant) =>
            variant.variantOptions.every((variantOption, i) => {
              if (i === 0 && variantOption.id !== selectedOptionValueIds[i])
                return false;

              return true;
            }),
        );

        frameSizeVariants = matchingFrameSizeVariants.map((variant) => ({
          productOptionId: variant.variantOptions[1].id,
          variant: this.data.variants.find(
            ({ id }) => id === variant.variantId,
          ),
        }));
      }
    }

    this.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { variant, frameSizeVariants, isWaitlist, isComingSoon },
      }),
    );
  }
}

if (!customElements.get("product-form-selectors")) {
  customElements.define("product-form-selectors", ProductFormSelectors);
}
